import { Link } from "react-router-dom"
import './notfound.css';

const NotFound = () => {
  
  return (
    <div className="404-page">
      <h1>
        404  
      </h1>
      <p>
        Something went wrong... <Link to={"/"}>Click here</Link> to go back to Home Page.
      </p>
    </div>
  );

};

export default NotFound